import React from "react";

import styles from "./FullPageLoader.module.scss";

const FullPageLoader = () => {
  return (
    <div class={styles.loaderPage}>
      <div class={styles.loader}></div>
      <div class={styles.loaderText}>Please wait, we’re getting things ready...</div>
    </div>
  );
};

export default FullPageLoader;
